import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "../interseptor/axiosConf";


const fetchShelveData = () => {
    const beURL = localStorage.getItem('BE_Domain');
    return axios.get(`${beURL}/api/shelves`).then(res => res.data.shelves);

}
export const useShelveData = () => {

    return useQuery({
        queryKey:['shelves_data'],
        queryFn: fetchShelveData,
        cacheTime:6000,
    });
}

export const useAddShelve =()=>{

    return useMutation({
        mutationFn: async (newShelve)=>{
            const { data } = await axios.post('/api/create/shelve', newShelve);
            return data;
        }
    })
}

export const useUpdateShelve =()=>{

    return useMutation({
        mutationFn: async (shelveData)=>{
            const { data } = await axios.post('/api/update/shelve', shelveData);
            return data;
        }
    })
}

